export default "__VITE_ASSET__7b74d518__"